import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { TableEditColumn } from '@devexpress/dx-react-grid-material-ui';

const KebabCommandCell = ({ children, onEdit, ...restProps }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const commands = {};

  React.Children.forEach(children, (child) => {
    if (child?.props?.id) commands[child.props.id] = child.props.onExecute;
  });

  const closeMenu = (event) => {
    event?.stopPropagation?.();
    setAnchorEl(null);
  };

  const execute = (command) => (event) => {
    event.stopPropagation();
    closeMenu();
    command?.();
  };

  // Save and Cancel must remain visible while a row is being edited.
  if (!commands.edit && !commands.delete) {
    return <TableEditColumn.Cell {...restProps}>{children}</TableEditColumn.Cell>;
  }

  return (
    <TableEditColumn.Cell
      {...restProps}
      onClick={(event) => event.stopPropagation()}
      onDoubleClick={(event) => event.stopPropagation()}
      style={{ ...restProps.style, textAlign: 'center' }}
    >
      <IconButton
        aria-label="Purchase actions"
        onClick={(event) => {
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
        }}
        size="small"
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
        onClick={(event) => event.stopPropagation()}
        onMouseDown={(event) => event.stopPropagation()}
      >
        {commands.edit && (
          <MenuItem onClick={execute(onEdit || commands.edit)}>
            <ListItemIcon>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Edit</ListItemText>
          </MenuItem>
        )}
        {commands.delete && (
          <MenuItem onClick={execute(commands.delete)}>
            <ListItemIcon>
              <DeleteIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Delete</ListItemText>
          </MenuItem>
        )}
      </Menu>
    </TableEditColumn.Cell>
  );
};

KebabCommandCell.propTypes = {
  children: PropTypes.node,
  onEdit: PropTypes.func
};

export default KebabCommandCell;
